export enum SettingsManagerWatermark {
  Default = 'default', // none
  Demo = 'demo',
  Examples = 'examples',
}
